// HTTP 207 is fetch-successful but means at least one publication target failed.
export async function readPublishResult(response) {
  const data = await response.json();
  const failures = (Array.isArray(data?.results) ? data.results : []).filter(result => result?.error);
  if (!response.ok || response.status === 207 || data?.ok !== true || failures.length) {
    const message = failures.length
      ? 'Publish failed: publication was not completed for every target. Check the current published version before retrying.'
      : (data?.message || 'Publish failed.');
    throw Object.assign(new Error(message), { status: response.status, code: data?.error });
  }
  return data;
}
